module.exports = __webpack_public_path__ + "static/score-33ba883e1ebf2da31648b944f08a7c06.png";